<template>
    <div class="card" style="position: relative; overflow: hidden">
        <div class="card-title"> {{ employee.name }}</div>
        <div class="card-subtitle"> <small> {{ employee.department }} </small></div>
        <div class="card-subtitle"> {{ employee.position }}</div>
    </div>
</template>

<script>
export default {
    name: 'EmployerComponent',
    props: {
        employee: {
            type: Object,
            required: true
        }
    },
    computed: {
        profile() {
            return this.$store.getters.profile
        }
    },
    methods: {

    }
}
</script>

<style scoped>
small {
    opacity: .75;
}
</style>